import { Component } from '@angular/core';

import { IFloatingFilter, IFloatingFilterParams, SerializedTextFilter } from 'ag-grid-community';
import { AgFrameworkComponent } from 'ag-grid-angular';

export interface SelectFloatingFilterChange {
  model: SerializedTextFilter;
}

export interface SelectFloatingFilterParams extends IFloatingFilterParams<SerializedTextFilter, SelectFloatingFilterChange> {
  value: string;
  options: string[];
}

@Component({
  template: `
      <select [(ngModel)]="currentValue"
              (ngModelChange)="valueChanged()">
        <option *ngFor="let option of options"
                [ngValue]="option">{{option}}</option>
      </select>
    `
})
export class SelectFloatingFilterComponent implements
  IFloatingFilter<SerializedTextFilter, SelectFloatingFilterChange, SelectFloatingFilterParams>,
  AgFrameworkComponent<SelectFloatingFilterParams> {
  private params: SelectFloatingFilterParams;
  public options: string[];
  public currentValue: string;

  agInit(params: SelectFloatingFilterParams): void {
    this.params = params;
    this.options = this.params.options;
    this.currentValue = this.params.value;
    this.valueChanged();
  }

  valueChanged() {
    this.params.onFloatingFilterChanged({ model: this.buildModel() });
  }

  onParentModelChanged(parentModel: SerializedTextFilter): void {
    this.currentValue = parentModel ? parentModel.filter : '';
  }

  buildModel(): SerializedTextFilter {
    if (this.currentValue === '') {
      return null;
    }
    return {
      filterType: 'string',
      type: 'contains',
      filter: this.currentValue
    };
  }

}
